// extracted by mini-css-extract-plugin
module.exports = {"container":"CookieBanner_container__2rUEr","text":"CookieBanner_text__QCn17","button":"CookieBanner_button__1YMnC"};